import { account } from '@/apis';

export default {
  namespaced: true,
  state: {
    accountPage: {
      list: [],
      total: 0,
    },
    accountDetail: null,
    formatIdList: [],
    cityList: [],
    storeList: [],
  },
  mutations: {
    fetchPageStart(state) {
      Object.assign(state.accountPage, {
        list: [],
        total: 0,
      });
    },
    fetchPageSuccess(state, data) {
      const { list, total } = data;
      Object.assign(state.accountPage, {
        list,
        total,
      });
    },
    fetchDetailStart(state) {
      state.accountDetail = null;
    },
    fetchDetailSuccess(state, data) {
      state.accountDetail = data;
    },
    fetchFormatListStart(state) {
      state.formatIdList = [];
    },
    fetchFormatListSuccess(state, data) {
      const array = [];
      (data || []).forEach((item) => {
        array.push({
          label: item.name,
          value: item.id,
        });
      });
      state.formatIdList = array;
    },
    fetchCityListStart(state) {
      state.cityList = [];
    },
    fetchCityListSuccess(state, data) {
      const array = [];
      (data || []).forEach((item) => {
        const { name, id, list } = item;
        const children = [];
        (list || []).forEach((item) => {
          children.push({
            title: item.name,
            value: item.id,
            key: item.id,
          });
        });
        array.push({
          title: name,
          value: id,
          key: id,
          children,
        });
      });
      state.cityList = array;
    },
    fetchStoreListStart(state) {
      state.storeList = [];
    },
    fetchStoreListSuccess(state, data) {
      const array = [];
      (data || []).forEach((item) => {
        const { id, storeName } = item;
        array.push({
          label: storeName,
          value: id,
        });
      });
      state.storeList = array;
    },
  },
  actions: {
    async fetchPage({ commit }, payload) {
      commit('fetchPageStart');
      const data = await account.fetchPage(payload);
      commit('fetchPageSuccess', data);
    },
    async fetchDetail({ commit }, payload) {
      commit('fetchDetailStart');
      commit('fetchDetailSuccess', payload);
    },
    async add(context, payload) {
      await account.add(payload);
    },
    async edit(context, payload) {
      await account.edit(payload);
    },
    async updateStatus(context, payload) {
      await account.updateStatus(payload);
    },
    async del(context, payload) {
      await account.del(payload);
    },
    async unLock(context, payload) {
      await account.unLock(payload);
    },
    async fetchFormatList({ commit }, payload) {
      commit('fetchFormatListStart');
      const data = await account.fetchFormatList(payload);
      commit('fetchFormatListSuccess', data);
    },
    async fetchCityList({ commit }, payload) {
      commit('fetchCityListStart');
      const data = await account.fetchCityList(payload);
      commit('fetchCityListSuccess', data);
    },
    async fetchStoreList({ commit }, payload) {
      commit('fetchStoreListStart');
      const data = await account.fetchStoreList(payload);
      commit('fetchStoreListSuccess', data);
    },
  },
};
